import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=8797b66e&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=ts"
export * from "./NewsCarousel.vue?vue&type=script&lang=ts"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=8797b66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8797b66e",
  null
  
)

export default component.exports